module.exports = __webpack_public_path__ + "img/animals_bear.eb57a45b.png";